import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/link-expired")({
  staticData: { title: "Link Expired" },
  component: lazyRouteComponent(
    () => import("#pages/login/link-expired.tsx"),
    "LinkExpired",
  ),
})
